import PhoneInputCommon, {
  type PhoneInputProps as PhoneInputPropsCommon
} from "@common/controls/Inputs/PhoneInput/component";
import classNames from "classnames";
import React from "react";

export type PhoneInputProps = Omit<PhoneInputPropsCommon, "context" | "inputClassName"> & {
  containerClassName?: string;
};

const PhoneInput = React.forwardRef(
  ({ className, containerClassName, ...props }: PhoneInputProps, ref: React.RefObject<HTMLDivElement>) => (
    <PhoneInputCommon ref={ref} {...props} className={classNames(className, containerClassName)} />
  )
);

export default PhoneInput;
